import { getEncodedCurrentPath } from "@/components/common/LocationService";
import { getExamineeAxios } from "@/utils/axios";
import { AxiosResponse } from "axios";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { SleepCheckupInfo } from "./Types";

export function getSleepCheckupInfo(
  sleepCheckUpId: string,
  currentPath: string
) {
  return getExamineeAxios(currentPath).get(
    `/api/sleep_checkup_info/${sleepCheckUpId}/`
  );
}

export function useSleepCheckupInfoAPI() {
  const location = useLocation();
  return useMemo(
    () => ({
      /**
       * 判定基準取得API
       *
       * @see https://www.notion.so/accelstars/API-Interface-9cc9f3444d7a435494fd3e3431048572?pvs=4#de315cf0ffaa497e82c37aa40cab5adb
       * @param uuid sleep_checkup_info_uuid
       * @returns Promise<AxiosResponse<JudgementTable, any>>
       */
      get: (sleepCheckupId: string) =>
        getSleepCheckupInfo(
          sleepCheckupId,
          getEncodedCurrentPath(location)
        ) as Promise<AxiosResponse<SleepCheckupInfo>>,
    }),
    [location]
  );
}
